var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54248 0.5C12.3083 0.500129 14.5589 2.76477 14.5591 5.56836C14.5591 8.37212 12.3084 10.6376 9.54248 10.6377C6.77646 10.6377 4.52588 8.3722 4.52588 5.56836C4.52607 2.76469 6.77658 0.5 9.54248 0.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00083 17.5145C0.971167 16.1672 1.73041 13.3828 5.00464 13.0236C8.35005 13.0236 12.3301 13.0236 13.902 13.0236C15.3256 13.1433 18.1372 14.2092 17.9948 17.5145",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersNav);
export default __webpack_public_path__ + "static/media/users-nav.6c3aa13b3868154ee95f08b17d331f4a.svg";
export { ForwardRef as ReactComponent };